import { createSlice } from "@reduxjs/toolkit";
import { updateAppAction } from "../action/updateAppAction";
import { UpdateAppData } from "../types/UpdateAppType";
import { updateAddressAction } from "../action/updateAddressAction";

const initialState: UpdateAppData = {
  data: {},
  loading: false,
  error: null,
};

const updateAddressSlice = createSlice({
  name: "updateAddressSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateAddressAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAddressAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateAddressAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const updateAddressReducer = updateAddressSlice.reducer;
